import { FC } from 'react';
import StateBadgeAvisoObra from './Chips/StateBadgeAvisoObra';
import DataTable from '../../../components/DataTable/DataTable';
import { useTranslation } from 'react-i18next';
import { useGetTiposObraQuery } from '../../../services/avisoObraApi';
import { getDate } from '../../../utils/common';
interface AvisoObraGridProps {
    avisos: any;
    filters: any;
    setFilters: any;
    isFetching: boolean;
    onSelectRow?: (event: React.MouseEvent<HTMLElement>, item: any) => void;
}

const isFechaVencida = (fechaFinStr: string | null | undefined): boolean => {
    if (!fechaFinStr) return false;

    const fechaFin = new Date(fechaFinStr);
    if (isNaN(fechaFin.getTime())) return false;

    const hoy = new Date();
    const diffMs = fechaFin.getTime() - hoy.getTime();
    const diffDias = diffMs / (1000 * 60 * 60 * 24);

    return diffDias <= 10;
};

const AvisoObraGrid: FC<AvisoObraGridProps> = ({
    avisos,
    filters,
    setFilters,
    isFetching,
    onSelectRow
}) => {
    const { t } = useTranslation('avisoObra');
    const { data: tiposObraData } = useGetTiposObraQuery();

    const columnTitles = [
        t('table.columns.nroObra'),
        t('table.columns.direccion'),
        t('table.columns.localidad'),
        t('table.columns.provincia'),
        t('table.columns.programa'),
        t('table.columns.tipoObra'),
        t('table.columns.inicio'),
        t('table.columns.fin'),
        t('table.columns.estado'),
        t('table.columns.fechaAlta'),
        t('table.columns.acciones')
    ];
    const columnWidths = ['5%', '20%', '10%', '10%', '10%', '10%', '5%', '10%', '5%'];

    return (
        <DataTable
            columnTitles={columnTitles}
            columnWidths={columnWidths}
            items={avisos}
            filters={filters}
            setFilters={setFilters}
            onSelectRow={() => {}}
            selectedItemFromAction={null}
            menuOpen={false}
            isFetching={isFetching}
            noPaginated={false}
            headers={[
                { type: 'data', upperLabel: (item: any) => item?.id || '-' },
                { type: 'data', upperLabel: (item: any) => item?.direccion?.calle || '-' },
                {
                    type: 'data',
                    upperLabel: (item: any) => item?.direccion?.localidad?.nombre || '-'
                },
                {
                    type: 'data',
                    upperLabel: (item: any) => item?.direccion?.localidad?.provincia?.nombre || '-'
                },
                {
                    type: 'data',
                    upperLabel: (item: any) => (item?.programaSeguridadPresentado ? 'Sí' : 'No')
                },
                {
                    type: 'data',
                    upperLabel: (item: any) => {
                        const tipoIds: number[] =
                            item?.avisosObraTiposSubtipos?.map((t: any) => t.idTipoObra) ?? [];

                        const nombres: string[] = tipoIds.map((id) => {
                            const tipo = tiposObraData?.find((t) => t.id === id);
                            return tipo?.nombre ?? `#${id}`;
                        });

                        return nombres.length ? nombres.join(', ') : '-';
                    }
                },

                { type: 'data', upperLabel: (item: any) => getDate(item?.fechaInicio) || '-' },
                {
                    type: 'data',
                    upperLabel: (item: any) => (
                        <span
                            style={{
                                color: isFechaVencida(item?.fechaFin) ? '#D32F2F' : 'inherit',
                                fontWeight: isFechaVencida(item?.fechaFin) ? 700 : 400
                            }}
                        >
                            {getDate(item?.fechaFin) || '-'}
                        </span>
                    )
                },
                {
                    type: 'data',
                    upperLabel: (item: any) => (
                        <StateBadgeAvisoObra hideIcon state={item?.idEstadosAvisoObra} />
                    )
                },
                { type: 'data', upperLabel: (item: any) => getDate(item?.fechaAlta) || '-' },
                { type: 'action', onClick: (event: any, item: any) => onSelectRow?.(event, item) }
            ]}
        />
    );
};

export default AvisoObraGrid;
